import React from "react";

import { List, Datagrid, TextField, EditButton, ShowButton, DeleteWithConfirmButton } from "react-admin";
import { EmptyList } from "../../../../common/components";
import { orderFilter } from "../../Partials/Filters";
import { CreateActions } from "../../../../utils/customActions";

const ListPublicProcurementActOrders = () => {
  return (
    <List
      actions={<CreateActions />}
      filters={orderFilter}
    >
      <Datagrid
        bulkActionButtons={false}
        empty={<EmptyList />}
      >
        <TextField
          label="№"
          source="id"
          sortable={false}
        />
        <TextField
          label="Предмет на поръчката"
          source="title"
          sortable={false}
        />
        <ShowButton />
        <EditButton />
        <DeleteWithConfirmButton />
      </Datagrid>
    </List>
  );
};

export default ListPublicProcurementActOrders;
